import { render, staticRenderFns } from "./FeeDetailFooter.vue?vue&type=template&id=bf5be2da&scoped=true"
import script from "./FeeDetailFooter.vue?vue&type=script&lang=js"
export * from "./FeeDetailFooter.vue?vue&type=script&lang=js"
import style0 from "./FeeDetailFooter.vue?vue&type=style&index=0&id=bf5be2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5be2da",
  null
  
)

export default component.exports